<template>
  <v-container>
    <v-flex xs12 sm12 md8 lg8 xl6 style="margin:auto">
      <v-card>
        <v-card-text>
          <v-form>
            <h4 class="primary--text">Config Asset Theme </h4>
            <v-text-field type="text" :label="'Theme Name*'" v-model.trim="themeName"
                          name="themeName"
                          key="themeName"
                          v-validate="'required'" maxLength="50"
                          :error-messages="errors.first('themeName')"
                          :data-vv-as="'themeName'"
            ></v-text-field>
            <v-text-field type="text" :label="'Theme Url Android'" v-model.trim="themeUrlAndroid"
                          name="themeUrlAndroid"
                          key="themeUrlAndroid"
                          :disabled="true"
                          v-validate="'required'" maxLength="50"
                          :error-messages="errors.first('themeUrlAndroid')"
                          :data-vv-as="$t('themeUrlAndroid')"
            ></v-text-field>
            <div style="text-align: center">
              <i-upload :label="'Theme URL Android'"
                        v-model.trim="attachIdAndroid" :multifile="false"
                        name="attachIdAndroid"
                        :data-vv-as="$t('Theme URL Android')"
                        :error-messages="errors.first('Theme URL Android')"
              />
            </div>
            <v-text-field type="text" :label="'Theme Url Ios'" v-model.trim="themeUrlIos"
                          name="themeUrlIos"
                          key="themeUrlIos"
                          :disabled="true"
                          v-validate="'required'" maxLength="50"
                          :error-messages="errors.first('themeUrlIos')"
                          :data-vv-as="$t('themeUrlIos')"
            ></v-text-field>
            <div style="text-align: center">
              <i-upload :label="'Theme URL Ios'"
                        v-model.trim="attachIdIos" :multifile="false"
                        name="attachIdIos"
                        :data-vv-as="$t('Theme URL Ios')"
                        :error-messages="errors.first('Theme URL Ios')"
              />
            </div>
            <v-text-field type="text" :label="'Theme Url Pc'" v-model.trim="themeUrlPc"
                          name="themeUrlPc"
                          key="themeUrlPc"
                          :disabled="true"
                          v-validate="'required'" maxLength="50"
                          :error-messages="errors.first('themeUrlPc')"
                          :data-vv-as="$t('themeUrlPc')"
            ></v-text-field>
            <div style="text-align: center">
              <i-upload :label="'Theme URL Pc'"
                        v-model.trim="attachIdPc" :multifile="false"
                        name="attachIdPc"
                        :data-vv-as="$t('Theme URL Pc')"
                        :error-messages="errors.first('Theme URL Pc')"
              />
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="yoprimary" dark @click="handleSubmit">
            {{$t('lang.common.save')}}
          </v-btn>
<!--          <v-btn color="cancel" @click="back">
            {{$t('lang.common.back')}}
          </v-btn>-->
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-container>
</template>
<script>
import IDatepicker from "@/components/form/DatePicker";
import IUpload from "@/components/form/Upload";
import {mapState} from "vuex";
import {CrudService, message} from "@/services";
import axios from "axios";
import {Validator} from "vee-validate";

export default {
  name: "Profile",
  components: {IDatepicker, IUpload},
  data() {
    return {
      submitted: false,
      user: {
        status: 1
      },
      values: {},
      lstProvice:[],
      themeName : this.themeName,
      themeUrlAndroid : this.themeUrlAndroid,
      themeUrlIos : this.themeUrlIos,
      themeUrlPc : this.themeUrlPc,
      attachIdAndroid: null,
      attachIdIos: null,
      attachIdPc: null,
      profile: {
        'workingAt': '',
        'experience': '',
        'email': '',
        'yoTarget': '',
        'cvId': null
      },
      disablePhone:false,
      disableEmail:false
    };
  },
  computed: mapState({
    loading: state => state.common.loading,
  }),
  methods: {
    handleSubmit(e) {
      this.submitted = true;
      console.log("user:", this.user);
      this.$validator.validate().then(valid => {
        if (valid) {
          this.profile.themeName = this.themeName;
          this.profile.themeUrlAndroid = this.themeUrlAndroid,
          this.profile.themeUrlIos = this.themeUrlIos,
          this.profile.themeUrlPc = this.themeUrlPc,
          this.profile.attachIdAndroid = this.attachIdAndroid;
          this.profile.attachIdIos = this.attachIdIos;
          this.profile.attachIdPc = this.attachIdPc;

          axios.post(process.env.VUE_APP_API_URL + "/notify/saveAssetTheme", this.profile).then(
              data => {
                if (data.success) {
                  message.success(this.$t('lang.common.update_success'));
                  location.reload();
                } else {
                  message.error(this.$t(data.message));
                }
              },
              error => {
                message.error(error);

              }
          )
        } else {
          message.error("Bạn nhập thiếu thông tin hoặc thông tin không đúng định dạng");
        }
      });
      return false;
    },
    back() {
      this.$router.go(-2);
    }
  },
  created() {
    axios.post(
        process.env.VUE_APP_API_URL + "/notify/searchAllAssetTheme1", {status: 1}
    )
        .then(
            (data) => {
              if (data != null && data != "") {
                var dataJson = JSON.parse(data.items[0].content);
                console.log(dataJson.themeName);
                this.themeName = dataJson.themeName;
                this.themeUrlAndroid = dataJson.themeUrlAndroid;
                this.themeUrlIos = dataJson.themeUrlIos;
                this.themeUrlPc = dataJson.themeUrlPc;

              } else {
                this.themeName = '';
                this.themeUrl = '';
              }
            },
            error => {
              console.log(error);
            }
        );
  },
  mounted() {
    let me = this;
    const usernameUnique = (value) => {
      if (me.initUsername == value) {
        return true;
      }
      return axios.get(`${process.env.VUE_APP_API_URL}/user/validate-username?username=${value}`).then((data) => {
        //debugger;
        return {
          valid: data.valid,
          data: {
            message: data.message
          }
        };
      });
    };

    if (this.$route.params.id) {
      this.$refs.password.focus();
    }
  }
};
</script>